import { AdminRouter } from 'stylemix-vue-admin'

AdminRouter.addRoute({
  path: '/zones',
  name: 'zones',
  component: () => import('./page-zones'),
})
